var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1570,
    height: 1635,
    viewBox: "0 0 1570 1635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2002_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.105 333.882C791.161 384.68 760.902 426.529 718.244 455.397C675.586 484.264 621.967 499.177 562.552 498.699C503.138 498.221 439.93 482.368 379.019 452.667C318.108 422.967 261.546 380.419 214.784 329.124L454.155 150.889L806.105 333.882Z",
    fill: "#F279EE",
    fillOpacity: 0.23
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2002_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M797.625 471.588C823.412 539.232 825.129 609.814 802.608 676.534C780.087 743.255 734.089 803.865 669.045 852.526C604.001 901.186 522.102 936.257 431.241 954.359C340.379 972.461 243.617 972.985 150.275 955.879L263.198 563.803L797.625 471.588Z",
    fill: "#7993F2",
    fillOpacity: 0.23
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2002_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1229.55 971.805C1189.79 1032.3 1133.55 1074.99 1066.27 1095.77C998.986 1116.55 922.92 1114.71 845.399 1090.44C767.879 1066.16 691.517 1020.27 623.67 957.182C555.824 894.092 498.78 815.93 458.033 730.228L842.056 592.381L1229.55 971.805Z",
    fill: "#00E0FF",
    fillOpacity: 0.23
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2002_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.463 860.588C846.524 911.906 882.751 971.704 900.654 1034.22C918.558 1096.74 917.535 1159.87 897.683 1217.54C877.831 1275.2 839.82 1325.45 787.312 1363.44C734.804 1401.44 669.568 1425.9 597.89 1434.47L479.539 1071.9L795.463 860.588Z",
    fill: "#00FF0A",
    fillOpacity: 0.18
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2002_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.117 351.112C696.383 294.419 765.633 260.262 842.195 251.931C918.757 243.6 1000.05 261.375 1078.25 303.545C1156.44 345.714 1228.9 410.856 1288.64 492.696C1348.38 574.535 1393.39 670.313 1419.34 770.801L978.356 839.026L641.117 351.112Z",
    fill: "#79F27D",
    fillOpacity: 0.23
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_8",
    x: 64.7837,
    y: 0.88916,
    width: 891.321,
    height: 647.821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2002_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2002_8",
    x: 0.275391,
    y: 321.589,
    width: 968.043,
    height: 796.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2002_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2002_8",
    x: 308.033,
    y: 442.381,
    width: 1071.52,
    height: 817.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2002_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2002_8",
    x: 279.539,
    y: 660.589,
    width: 833.828,
    height: 973.883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_2002_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2002_8",
    x: 491.117,
    y: 99.9299,
    width: 1078.22,
    height: 889.096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2002_8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadows);
export default __webpack_public_path__ + "static/media/shadows.d4c75d20119f4b7d3e99359f68aa77a9.svg";
export { ForwardRef as ReactComponent };